export const resetSuccessInfo = {
  text: "Password reset request has been sent.",
  subtext:
    "You should receive a mail shortly with password reset instruction. If no email is received, please check your SPAM or JUNK email folder.",
  buttonTitle: "Resend Email",
};

export const resetReqInfo = {
  text: "Forgot your password?",
  subtext:
    "Can’t remeber your password? Don’t worry a email will be sent to your address to reset the password.",
  buttonTitle: "Send",
};
